import React from 'react';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';
import { sketchTiltStyle } from '../../utils/sketchTilt';

export type SketchBoxTilt = 'none' | 'left' | 'right' | 'auto';

interface SketchBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  tilt?: SketchBoxTilt;
  /** Stable seed for auto tilt (defaults to React useId). */
  tiltSeed?: string | number;
}

export const SketchBox = React.forwardRef<HTMLDivElement, SketchBoxProps>(
  ({ className, tilt = 'auto', tiltSeed, style, children, ...props }, ref) => {
    const { isSketchy } = useDesignMode();
    const autoId = React.useId();
    const seed = tiltSeed ?? autoId;

    const tiltStyle =
      isSketchy && tilt === 'auto' ? sketchTiltStyle(seed) : undefined;

    return (
      <div
        ref={ref}
        className={classNames(
          isSketchy
            ? classNames(
                'sketch-box',
                tilt !== 'none' && 'sketch-wobble',
                tilt === 'left' && 'sketch-box-tilt-left',
                tilt === 'right' && 'sketch-box-tilt-right'
              )
            : 'rounded-xl border shadow-sm bg-[var(--color-surface)] border-[var(--color-border)]',
          className
        )}
        style={{ ...tiltStyle, ...style }}
        {...props}
      >
        {children}
      </div>
    );
  }
);

SketchBox.displayName = 'SketchBox';
